import { isNative } from './native';

/**
 * Weekly Insights gate (docs/WEEKLY_INSIGHTS_SPEC.md §1, decision D5,
 * 13 Oct 2026): WEB ONLY until users have validated the feature. Native
 * builds may carry the code, but every insight surface renders only when
 * this returns true. Turning it on for native is Chad's decision after the
 * §6 validation gate — change it here, nowhere else.
 * Source contract: src/native/__tests__/insightsGate.test.ts.
 */
export function weeklyInsightsEnabled(): boolean {
  return !isNative();
}
